import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CallState, LCS_API_CONFIG, LcsApiConfig } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getAppStartCallState } from 'src/app/app-start/app-start.selectors';
import { LoginDetails } from 'src/app/authentication/models/login-details.model';
import { reAuthenticate, reAuthenticationCancel, ssoLogin } from 'src/app/authentication/state/authentication.actions';
import { getLoginCallState, selectLoginError } from 'src/app/authentication/state/authentication.selector';
import { hasSaml2Authentication } from 'src/app/common-components/utils/sso-helper';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-login-dialog',
    styleUrls: ['./login-dialog.component.scss'],
    templateUrl: './login-dialog.component.html',
    standalone: false
})
export class LoginDialogComponent {
   appStartCallState: Observable<CallState>;

   loginCallState: Observable<CallState>;

   loginError$: Observable<string | null>;

   hasSaml2Authentication$: Observable<boolean | undefined>;

   constructor(
      private store: Store,
      @Inject(MAT_DIALOG_DATA) public data: { username: string },
      @Inject(LCS_API_CONFIG) apiConfig: LcsApiConfig
   ) {
      this.loginCallState = store.pipe(select(getLoginCallState));
      this.appStartCallState = store.pipe(select(getAppStartCallState));
      this.loginError$ = store.pipe(select(selectLoginError));
      this.hasSaml2Authentication$ = hasSaml2Authentication();
   }

   onLoginClick(loginDetail: LoginDetails): void {
      this.store.dispatch(reAuthenticate(loginDetail));
   }

   onCancelClick(): void {
      this.store.dispatch(reAuthenticationCancel());
   }

   onLoginWithSSO() {
      this.store.dispatch(ssoLogin({ fromDialog: true }));
   }
}
